import type {
    ComparisonRangeType,
    FilterObject,
    ReportFacet,
    ReportGap,
    ReportMap,
    SortDirection,
} from 'nutshell-core/types';

export type {ReportFacet, ReportGap} from 'nutshell-core/types';

export type ReportSegment =
    | 'assignees'
    | 'stages'
    | 'products'
    | 'outcomes'
    | 'sources'
    | 'tags'
    | 'competitors'
    | 'territories'
    | 'age'
    | 'value'
    | 'channels'
    | 'createdTime'
    | 'closedTime'
    | 'activityType'
    | 'actionType'
    | 'subscriptionStatus'
    | 'interactionType'
    | 'taskStatuses'
    | 'salesDocumentStatuses';

export type DateRangeType = 'createdTime' | 'closedTime' | 'period';

type Losses = 'losses';
type NewLeads = 'newleads';
type Sales = 'sales';
type Products = 'products';
type Forecast = 'forecast';
type Attribution = 'attribution';
type Funnel = 'funnel';
type Custom = 'custom';
type Activity = 'activity';
type Email = 'email';
type AudienceMembership = 'audienceMembership';
type EditionEngagement = 'editionEngagement';
type SmsEditionEngagement = 'smsEditionEngagement';
type DripEditionEngagement = 'dripEditionEngagement';
type SmsDripEditionEngagement = 'smsDripEditionEngagement';
type FormEngagement = 'formEngagement';
type SiteAnalytics = 'siteAnalytics';
type McfxCompanies = 'mcfxcompanies';
type Scheduler = 'scheduler';
type Competitors = 'competitors';
type Dashboard = 'dashboard';
type EngagementDashboard = 'engagementDashboard';
type LandingPages = 'landingPages';
type Tasks = 'tasks';
type Engagement = 'engagement';
type Quotes = 'quotes';
type Invoices = 'invoices';
type EngagementLeads = 'engagementLeads';
type EngagementBarLeads = 'engagementBarLeads';
type EngagementSales = 'engagementSales';
type WidgetOpens = 'widgetOpens';
type CompletedActions = 'completedActions';
type Visitors = 'visitors';
type Chatbot = 'chatbot';
type SchedulerReport = 'schedulerReport';

export type LeadsReportKey =
    | Losses
    | NewLeads
    | Sales
    | Products
    | Forecast
    | Attribution
    | Custom
    | EngagementLeads
    | EngagementSales;
export type FunnelReportKey = Funnel;
export type ReportKey =
    | LeadsReportKey
    | FunnelReportKey
    | Activity
    | Email
    | AudienceMembership
    | EditionEngagement
    | SmsEditionEngagement
    | DripEditionEngagement
    | SmsDripEditionEngagement
    | FormEngagement
    | SiteAnalytics
    | McfxCompanies
    | Scheduler
    | Competitors
    | Dashboard
    | EngagementDashboard
    | LandingPages
    | Tasks
    | Engagement
    | Quotes
    | Invoices
    | WidgetOpens
    | CompletedActions
    | Visitors
    | EngagementBarLeads
    | Chatbot
    | SchedulerReport;

/* Types used by PHP to define which type of report is being saved */
type ReportActivitySavedType = 'report_activity';
type ReportEmailSavedType = 'report_email';
type ReportForecastSavedType = 'report_forecast';
type ReportAttributionSavedType = 'report_attribution';
type ReportFunnelSavedType = 'report_funnel';
type ReportLossesSavedType = 'report_losses';
type ReportNewLeadsSavedType = 'report_newleads';
type ReportSalesSavedType = 'report_sales';
type ReportProductsSavedType = 'report_products';
type ReportCustomSavedType = 'report_custom';
type ReportTasksSavedType = 'report_tasks';
type ReportEngagementSavedType = 'report_engagement';
export type ReportSavedTypeKey =
    | ReportActivitySavedType
    | ReportEmailSavedType
    | ReportForecastSavedType
    | ReportAttributionSavedType
    | ReportFunnelSavedType
    | ReportLossesSavedType
    | ReportNewLeadsSavedType
    | ReportSalesSavedType
    | ReportProductsSavedType
    | ReportCustomSavedType
    | ReportTasksSavedType
    | ReportEngagementSavedType;

export const LOSSES_SAVED_TYPE = 'report_losses';
export const NEW_LEADS_SAVED_TYPE = 'report_newleads';
export const SALES_SAVED_TYPE = 'report_sales';
export const PRODUCTS_SAVED_TYPE = 'report_products';
export const FORECAST_SAVED_TYPE = 'report_forecast';
export const ATTRIBUTION_SAVED_TYPE = 'report_attribution';
export const FUNNEL_SAVED_TYPE = 'report_funnel';
export const CUSTOM_SAVED_TYPE = 'report_custom';
export const ACTIVITY_SAVED_TYPE = 'report_activity';
export const EMAIL_SAVED_TYPE = 'report_email';
export const TASKS_SAVED_TYPE = 'report_tasks';
export const ENGAGEMENT_SAVED_TYPE = 'report_engagement';
/* End PHP saved report types */

export const LOSSES = 'losses';
export const NEW_LEADS = 'newleads';
export const SALES = 'sales';
export const PRODUCTS = 'products';
export const FORECAST = 'forecast';
export const FUNNEL = 'funnel';
export const CUSTOM = 'custom';
export const ACTIVITY = 'activity';
export const EMAIL = 'email';
export const AUDIENCE_MEMBERSHIP = 'audienceMembership';
export const EDITION_ENGAGEMENT = 'editionEngagement';
export const SMS_EDITION_ENGAGEMENT = 'smsEditionEngagement';
export const DRIP_EDITION_ENGAGEMENT = 'dripEditionEngagement';
export const SMS_DRIP_EDITION_ENGAGEMENT = 'smsDripEditionEngagement';
export const FORM_ENGAGEMENT = 'formEngagement';
export const SITE_ANALYTICS = 'siteAnalytics';
export const ATTRIBUTION = 'attribution';
export const MCFXCOMPANIES = 'mcfxcompanies';
export const SCHEDULER = 'scheduler';
export const COMPETITORS = 'competitors';
export const DASHBOARD = 'dashboard';
export const ENGAGEMENT_DASHBOARD = 'engagementDashboard';
export const LANDING_PAGES = 'landingPages';
export const TASKS = 'tasks';
export const ENGAGEMENT = 'engagement';
export const QUOTES = 'quotes';
export const INVOICES = 'invoices';
export const ENGAGEMENT_LEADS = 'engagementLeads';
export const ENGAGEMENT_BAR_LEADS = 'engagementBarLeads';
export const ENGAGEMENT_SALES = 'engagementSales';
export const WIDGET_OPENS = 'widgetOpens';
export const COMPLETED_ACTIONS = 'completedActions';
export const VISITORS = 'visitors';
export const CHATBOT = 'chatbot';
export const SCHEDULER_REPORT = 'schedulerReport';

export type ActivityReportPjaxResponseType = {
    success: boolean;
    isExportable: boolean;
    table: string;
    numPages: number;
};

type LeadReportTab = 'details' | 'leads';

// URL match types come directly from what we tell ReactRouter to put into
// their url 'match' object. Therefore, we can use exact object typing here.
export type LeadReportUrlMatch = {
    params: {
        report: ReportKey;
        tab: LeadReportTab;
    };
};

type LeadListExportKey = 'leadlist';
type ReportDataExportKey = 'reportdata';
type ReportChartExportKey = 'reportchart';
type ReportActivityDetailsExportKey = 'activitydetails';
type ReportActivityOverviewExportKey = 'activityoverview';
type ReportFunnelExportKey = 'funnel';
type ReportProductsExportKey = 'products';

export type ExportKey =
    | LeadListExportKey
    | ReportDataExportKey
    | ReportChartExportKey
    | ReportActivityDetailsExportKey
    | ReportActivityOverviewExportKey
    | ReportFunnelExportKey
    | ReportProductsExportKey;

export const LEAD_LIST_EXPORT_KEY = 'leadlist';
export const REPORT_DATA_EXPORT_KEY = 'reportdata';
export const REPORT_CHART_EXPORT_KEY = 'reportchart';
export const REPORT_ACTIVITY_DETAILS_EXPORT_KEY = 'activitydetails';
export const REPORT_ACTIVITY_OVERVIEW_EXPORT_KEY = 'activityoverview';
export const REPORT_FUNNEL_EXPORT_KEY = 'funnel';
export const REPORT_PRODUCTS_EXPORT_KEY = 'products';
export const QUOTA_NAME = 'Quota';
export const QUOTA_REPORT_KEY = 'quota';

export type ReportId = string;

export type ChartReportParams = {
    id?: ReportId;
    gap: ReportGap;
    facet: ReportFacet;
    dateRangeType: DateRangeType;
    reportType?: string;
    segment?: ReportSegment;
    useConfidence?: string;
    compareTo?: ComparisonRangeType;
    groupByField?: ReportSegment;
};

export type ChartListParams<T> = {
    page: string;
    sort: string;
    // @ts-expect-error
    fields: Partial<Record<T, string>>;
};

export type SortParams = {
    by: string;
    direction: SortDirection;
};

export type VersionParam = 'a' | 'b' | 'both';

export type ReportURLParams<T> = {
    filter: FilterObject;
    report: ChartReportParams;
    list?: ChartListParams<T>;
    page?: string;
    sort?: SortParams;
    q?: string;
    version?: VersionParam;
};

export type ODRReportData = {
    chartData: Array<any>;
    exportLink?: string;
};

export type ReportInfo = {
    reports: Array<ReportMap>;
    referenceReports?: Array<ReportMap>;
};
